import React from 'react';

const Stat = ({ label, value, color = 'text-white' }) => (
  <div className="flex flex-col items-center border border-[#658d71] p-2.5 bg-[rgba(0,0,0,0.1)] flex-1">
    <span className={`text-xl font-black tabular-nums ${color}`}>{value}</span>
    <span className="text-[9px] uppercase tracking-widest text-[#658d71] font-bold mt-0.5">{label}</span>
  </div>
);

const InjuryStats = ({ players }) => {
  const total = players.length;
  const il10 = players.filter(p => p.status?.description?.includes('10')).length;
  const il60 = players.filter(p => p.status?.description?.includes('60')).length;
  const dtd = players.filter(p =>
    p.status?.description?.toLowerCase().includes('day-to-day')
  ).length;
  const pitchers = players.filter(p => p.position?.type === 'Pitcher').length;

  return (
    <div className="flex gap-2">
      <Stat label="Total" value={total} color="text-[#c4333e]" />
      <Stat label="10-Day IL" value={il10} color="text-[#d8ceb3]" />
      <Stat label="60-Day IL" value={il60} color="text-[#a9c9b1]" />
      <Stat label="Day-to-Day" value={dtd} color="text-[#d8ceb3]" />
      <Stat label="Pitchers" value={pitchers} color="text-[#a9c9b1]" />
    </div>
  );
};

export default InjuryStats;